/* eslint-disable no-nested-ternary */
import CellHOC from '@platform/react/hoc/list/cell'
import { useMemoRef } from '@platform/react/hook'
import { Grid } from '@mui/material'
import Icon from 'ui/Element/Icon'

/**
 * Custom styles for the component.
 *
 * @returns {Object}
 */
const cellStyles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    padding: '0.5rem',
  },
  circle: {
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '1.25rem',
  },
  icon: {
    textAlign: 'center',
  },
})

/**
 * Intended to display the icon of an OptionManagement scan.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellOptionManagementIcon = (classes, props = {}) => {
  const { password, pinIcon, optionIcon, qrIcon, type = 'option' } = props

  const icon = type === 'option'
    ? password
      ? optionIcon
      : qrIcon
    : pinIcon

  return (
    <Grid
      container
      justifyContent={'center'}
      alignContent={'center'}
      alignItems={'center'}
      className={classes.circle}
    >
      <Grid
        item
        component={Icon}

        size={32}
        shape={'circle'}
        color={'black'}
        source={icon.name}
        variant={icon.variant}
        background={'gray.930'}
        className={classes.icon}
      />
    </Grid>
  )
}

export default useMemoRef(CellHOC(ListItemCellOptionManagementIcon, cellStyles), props => [
  props.type,
  props.password,
])
